import { render, staticRenderFns } from "./CustomerMutations.vue?vue&type=template&id=597c354c&scoped=true&"
import script from "./CustomerMutations.vue?vue&type=script&lang=js&"
export * from "./CustomerMutations.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=597c354c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c354c",
  null
  
)

export default component.exports